// extracted by mini-css-extract-plugin
module.exports = {"container":"OptionCard_container__O5VIn","text":"OptionCard_text__sOLZ5","selected":"OptionCard_selected__3bLB-","disabled":"OptionCard_disabled__2ZWYn"};